exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box-loading[data-v-158b165b]{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;height:100%;-ms-flex-pack:center;justify-content:center;margin:0;width:100%}.box-loading .loader[data-v-158b165b]{width:60px;text-align:center;position:relative;opacity:0}.box-loading .loader.showing[data-v-158b165b]{opacity:1}.box-loading .loader .loader-wheel[data-v-158b165b]{animation:spin-data-v-158b165b 1s infinite linear;border:3px solid rgba(30,30,30,.5);border-left:4px solid #fff;border-radius:50%;height:60px;margin-bottom:10px;width:60px}.box-loading .loader .loader-text[data-v-158b165b]{top:20px;font-size:12px;position:absolute;margin:auto;width:100%}@keyframes spin-data-v-158b165b{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-158b165b","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Front/Loading/index.vue
// module id = 1027
// module chunks = 0